import $ from 'jquery';
window.jQuery = $;
window.$ = $;
if (typeof SERVER === 'object' && SERVER.USER !== null && typeof SERVER.USER === 'object') {
    $.ajaxSetup({
        headers: { 'X-LUMEN5-WORKSPACE': `${SERVER.USER.workspace_id}` },
    });
}
